// ----------------------------------------------------------------------
// <copyright file="Izenda.EmailConstants.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import localizer from 'share/localization/Izenda.Localizer';

const DELIVERY_METHOD = {
  link: 'link',
  embedded: 'Embedded HTML',
  attachment: 'attachment'
};

export default {
  EMAIL: {
    sale: 'mailto:sales@izenda.com',
    licenseAssistance: 'mailto:sales@izenda.com?Subject=License%20Assistance',
    connectionStringAssistance: 'mailto:customersupport@izenda.com?Subject=Connection%20String%20Assistance'
  },
  MESSAGE: {
    get M12a(){ return localizer.getText('EMAIL_MESSAGE_SENT_SUCCESSFULLY')},
    get M12b(){ return localizer.getText('EMAIL_MESSAGE_SENT_FAIL')}
  },
  get REQUIRE_CONSTRAINTS() {
    return {
      presence: {
        presence: true,
        message: localizer.getText('EMAIL_MESSAGE_CONSTRAINT')
      }
    };
  },
  get EMAIL_VALIDATION() {
    return {
      REGEX: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      MESSAGE(emails) {
        return localizer.getText('EMAIL_MESSAGE_VALIDATION') + emails.join('; ');
      }
    };
  },
  DELIVERY_METHOD,
  DELIVERY_OPTIONS: [
    {
      value: DELIVERY_METHOD.link,
      key: 'EmailingDeliveryMethodLink',
      get label() {
        return localizer.getText('COMMON_LABEL_LINK');
      }
    },
    {
      value: DELIVERY_METHOD.embedded,
      key: 'EmailingDeliveryMethodEmbeddedHTML',
      get label() {
        return localizer.getText('COMMON_LABEL_EMBEDDED_HTML');
      }
    },
    {
      value: DELIVERY_METHOD.attachment,
      key: 'EmailingDeliveryMethodAttachment',
      get label() {
        return localizer.getText('COMMON_LABEL_ATTACHMENT');
      }
    }
  ],
  ATTACH_TYPE_OPTIONS: [
    { value: 'Word', label: 'Word', key: 'EmailingAttachmentTypeWord' },
    { value: 'Excel', label: 'Excel', key: 'EmailingAttachmentTypeExcel' },
    { value: 'Pdf', label: 'PDF', key: 'EmailingAttachmentTypePdf' },
    { value: 'Csv', label: 'CSV', key: 'EmailingAttachmentTypeCsv' },
    { value: 'Xml', label: 'XML', key: 'EmailingAttachmentTypeXml' },
    { value: 'Json', label: 'JSON', key: 'EmailingAttachmentTypeJson' },
    {
      value: 'Definition',
      key: 'EmailingAttachmentTypeDefinition',
      get label() {
        return localizer.getText('PERMISSION_LABEL_DEFINITION');
      }
    }
  ],
  EMAIL_TYPE: {
    report: 'report',
    dashboard: 'dashboard'
  },
  EMAIL_SUBJECT: {
    KEY: 'Subject',
    CLASS: '.email-subject',
    DEFAULT: {
      report: '{reportName}',
      dashboard: '{dashboardName}'
    }
  },
  EMAIL_BODY: {
    KEY: 'Body',
    CLASS: '.email-body'
  },
  TEMPLATE_TYPE: 2
};



// WEBPACK FOOTER //
// ./ui/logic/data/Izenda.EmailConstants.js